import { PasteCleanupSettingsModel } from '@syncfusion/ej2-angular-richtexteditor'
import { ALL_CSS_PROPERTIES } from './ALL_CSS_PROPERTIES'

export const RtePasteCleanupSettings: PasteCleanupSettingsModel = {
  prompt: false,
  keepFormat: true,
  plainText: false,
  allowedStyleProps: ALL_CSS_PROPERTIES,
  deniedTags: [],
}
